<template>
  <div>
    <Modal
      class="AddChannelModel"
      width="800"
      v-model="channelValue"
      :closable="false"
      :mask-closable="false"
      :footer-hide="true"
    >
    <!-- 上面提示文字 -->
    <div class="tip-header">
      <span>{{ titleLayer === 1 ? '新建' : titleLayer === 2 ? '编辑' : '查看' }}渠道信息</span>
      <span class="iconfont ys-iconguanbi" @click="handleReset('formValidate')"></span>
    </div>
    <!-- form表单 -->
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" label-width="90">
      <FormItem prop="channel_code" style="margin-right: 18px;width: 100%;" label="渠道编码:" v-if="titleLayer !== 1">
        <Input class="ys_input_border_bottom" v-model="formValidate.channel_code" placeholder="请输入渠道编码" disabled/>
      </FormItem>
      <FormItem style="width: 100%;" prop="channel_cn_name" label="渠道名称:">
        <Input class="ys_input_border_bottom" v-model="formValidate.channel_cn_name" placeholder="请输入渠道名称" :disabled="titleLayer === 3"/>
      </FormItem>
      <FormItem prop="channel_type" style="margin-right: 14px;width: 100%;" label="渠道类型:">
        <Select v-model="formValidate.channel_type" placeholder="请选择渠道类型" :disabled="titleLayer === 3 || titleLayer === 2">
          <Option v-for="(item, index) in enum_list" :value="item.ivalue" :key="index">{{ item.cname }}</Option>
        </Select>
      </FormItem>
      <FormItem prop="channel_bk_desc" label="渠道描述:">
        <Input
          type="textarea"
          style="width: 100%;"
          v-model="formValidate.channel_bk_desc"
          placeholder="请输入渠道描述"
          :autosize="{minRows: 5,maxRows: 8}"
          :disabled="titleLayer === 3"/>
      </FormItem>
    </Form>
    <!-- 按钮组 -->
    <div class="btn-box">
      <Button  class="ys-cancel" @click="handleReset('formValidate')" style="width: 100px; margin-right: 20px">{{ titleLayer === 3 ? '关闭' : '取消' }}</Button>
      <Button class="ys-confirm" type="primary" @click="handleSubmit('formValidate')" style="width: 100px;" v-if="titleLayer !== 3">确认</Button>
    </div>
  </Modal>
  </div>
</template>
<script>
import { 
  mapActions
} from "vuex";
export default {
  props: {
    channelValue:{
      type: Boolean,
      defalut: true
    },
    titleLayer: {
      type: String,
      default: 1
    },
    editDetail: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      formValidate: {
        channel_code: '', // 渠道编码
        channel_cn_name: '', // 渠道名称
        channel_type: '', // 渠道类型
        channel_bk_desc: '', // 渠道描述
      },
      ruleValidate: {
        channel_code: [
          { required: true, message: '请输入渠道编码', trigger: 'blur' }
        ],
        channel_cn_name: [
          { required: true, message: '请输入渠道名称', trigger: 'blur' }
        ],
        channel_type: [
          { required: true, message: '请选择渠道类型', type: 'number', trigger: 'change' }
        ],
        channel_bk_desc: [
          { required: true, message: '请输入渠道描述', trigger: 'blur' }
        ]
      },
      enum_list: null, // 枚举类
    }
  },
  methods: {
    ...mapActions([
      'getEnumChanne', // 获取枚举类
      'addChannleAction', // 新建保存
      'channleQueryChannelAction', // 编辑回显
      'channleUpdateChannelAction', // 编辑保存
    ]),
    // 确认
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.titleLayer === 1 ? this.addChannleActions() : this.channleUpdateChannelActions();
        } else {
          this.$Message.error('请完善信息！');
        }
      })
    },
    // 取消
    handleReset(name) {
      this.$refs[name].resetFields();
      this.$emit('on-channel-click');
    },
    // 获取枚举类
    async getEnumChannes() {
      try {
        const data = await this.getEnumChanne({class_name: 'ys.manufacture.framework.enu.CHANNEL_TYPE'});
        if (data.request_state) {
          this.enum_list = data.enum_list;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 新建保存
    async addChannleActions() {
      try {
        const data = await this.addChannleAction(this.formValidate);
        if (data.request_state) {
          this.$Message.success('保存成功~~');
          this.$emit('on-channel-click');
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 编辑回显
    async channleQueryChannelActions() {
      try {
        const data = await this.channleQueryChannelAction({channel_code: this.editDetail.channel_code});
        if (data.request_state) {
          this.formValidate.channel_cn_name = data.channel_cn_name; // 渠道名称
          this.formValidate.channel_type = data.channel_type; // 渠道类型
          this.formValidate.channel_bk_desc = data.channel_bk_desc; // 渠道描述
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 编辑保存
    async  channleUpdateChannelActions() {
      try {
        const data = await this.channleUpdateChannelAction(this.formValidate);
        if (data.request_state) {
          this.$Message.success('保存成功~~');
          this.$emit('on-channel-click');
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  mounted() {
    // 获取渠道类型
    this.getEnumChannes();
    if (this.titleLayer !== 1) {
      this.formValidate.channel_code = this.editDetail.channel_code;
      this.channleQueryChannelActions();
    }
  },
}
</script>
<style lang="less" scoped>
.AddChannelModel {
  .tip-header {
    width: 100%;
    height: 30px;
    line-height: 30px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin-bottom: 24px;
    span:nth-of-type(1) {
      font-size:18px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(179,195,226,1);
    }
    span:nth-of-type(2) {
      font-size: 28px;
    }
    span:nth-of-type(2):hover {
      cursor: pointer;
    }
  }
  .btn-box {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
    margin-top: 40px;
  }
  .protocolParameters {
    width: 100%;
    margin-bottom: 20px;
  }
}
</style>
